import styled from 'styled-components';
import View from '@sdk/components/primitives/View';
import FlexCenteredStyle from '@sdk/components/ui/FlexCenteredStyle';
import Column from '@sdk/components/ui/spacing/Column';
import Spinner from '@sdk/components/ui/Spinner';
import Text14 from '@sdk/components/ui/typography/Text14';

export const Container = styled(Column)<{ customWidth?: number }>`
  flex: 1;
  position: relative;
  cursor: pointer;
  ${({ customWidth }): string => customWidth && `max-width: ${customWidth}px;`}
`;

export const InputContainer = styled(Column)`
  position: realtive;
`;

export const PickerMenu = styled(Column)`
  position: absolute;
  z-index: 1;
  overflow-y: scroll;
  border-radius: 4px;
  background-color: ${({ theme }): string => theme.colors.white};
  top: 100%;
  box-shadow: 0 10px 40px 0 ${({ theme }): string => theme.colors.boxShadowDarker};
  width: 100%;
  list-style: none;
  outline: none;
`;

export const PickerItem = styled.li<{ highlighted?: boolean }>`
  cursor: pointer;
  padding: 10px;
  margin: 0 10px;
  border-radius: 4px;
  background-color: ${({ highlighted, theme }): string =>
    highlighted ? theme.colors.hoverBrand : theme.colors.white};

  color: ${({ highlighted, theme }): string =>
    highlighted ? theme.colors.primary : theme.colors.gray};

  &:first-child {
    margin-top: 10px;
  }
  &:last-child {
    margin-bottom: 10px;
  }
  &:hover {
    background-color: ${({ theme }): string => theme.colors.hoverBrand};
  }
`;

export const PickerItemText = styled(Text14)<{ highlighted?: boolean }>`
  color: ${({ highlighted, theme }): string =>
    highlighted ? theme.colors.primary : theme.colors.gray};
`;

export const Postfix = styled(View)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding-right: 10px;
  ${FlexCenteredStyle};
`;

export const StyledSpiner = styled(Spinner)`
  justify-content: flex-end;
  align-items: flex-end;
`;
